import { enqueueSnackbar } from 'actions';

import {
	GetUsersRequest,
	GetPendingUsersRequest,
	DeletePendingUserRequest,
	GetUsersStatsRequest,
	GetRolesRequest,
	GetOperatorsRequest,
	GetOperatorProjectsRequest,
	CreateUserRequest,
	GetUserRequest,
	EditUserRequest,
	ResendConfirmationEmailRequest,
	DeactivateUserRequest,
	DeleteUserRequest
} from '../requests/UsersRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const GET_USERS = 'GET_USERS';
export const GET_PENDING_USERS = 'GET_PENDING_USERS';
export const GET_USERS_STATS = 'GET_USERS_STATS';
export const TOGGLE_ADD_EDIT_USER_DIALOG = 'TOGGLE_ADD_EDIT_USER_DIALOG';
export const TOGGLE_ADD_PENDING_USERS_DIALOG = 'TOGGLE_ADD_PENDING_USERS_DIALOG';
export const TOGGLE_DELETE_USER_DIALOG = 'TOGGLE_DELETE_USER_DIALOG';
export const GET_ROLES = 'GET_ROLES';
export const GET_OPERATORS = 'GET_OPERATORS';
export const GET_OPERATOR_PROJECTS = 'GET_OPERATOR_PROJECTS';
export const GET_USER = 'GET_USER';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onSetInitialState = (value) => ({
	type: SET_INITIAL_STATE,
	formState: value
});

const onGetUsers = (value) => ({
	type: GET_USERS,
	users: value
});

const onGetPendingUsers = (value) => ({
	type: GET_PENDING_USERS,
	pendingUsers: value
});

const onGetUsersStats = (value) => ({
	type: GET_USERS_STATS,
	usersStats: value
});

const onToggleAddEditUserDialog = (openAddEditUserDialog, openAddEditUserDialogId) => ({
	type: TOGGLE_ADD_EDIT_USER_DIALOG,
	openAddEditUserDialog,
	openAddEditUserDialogId
});

const onToggleAddPendingUsersDialog = (openAddPendingUsersDialog) => ({
	type: TOGGLE_ADD_PENDING_USERS_DIALOG,
	openAddPendingUsersDialog
});

const onToggleDeleteUserDialog = (openDeleteUserDialog, openDeleteUserDialogId) => ({
	type: TOGGLE_DELETE_USER_DIALOG,
	openDeleteUserDialog,
	openDeleteUserDialogId
});

const onGetRoles = (value) => ({
	type: GET_ROLES,
	roles: value
});

const onGetOperators = (value) => ({
	type: GET_OPERATORS,
	operators: value
});

const onGetOperatorProjects = (value) => ({
	type: GET_OPERATOR_PROJECTS,
	operatorProjects: value
});

const onGetUser = (value) => ({
	type: GET_USER,
	user: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const SetInitialState = (value) => (dispatch) => {
	dispatch(onSetInitialState(value));
};

export const GetUsers = (role) => async (dispatch) => {
	await GetUsersRequest(role).then(response => {
		dispatch(onGetUsers(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetPendingUsers = () => async (dispatch) => {
	await GetPendingUsersRequest().then(response => {
		dispatch(onGetPendingUsers(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeletePendingUser = (userEmail) => async (dispatch) => {
	await DeletePendingUserRequest(userEmail).then(response => {
		dispatch(GetPendingUsers());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetUsersStats = () => async (dispatch) => {
	await GetUsersStatsRequest().then(response => {
		dispatch(onGetUsersStats(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleAddEditUserDialog = (openAddEditUserDialog, openAddEditUserDialogId) => (dispatch) => {
	dispatch(onToggleAddEditUserDialog(openAddEditUserDialog, openAddEditUserDialogId));
};

export const ToggleAddPendingUsersDialog = (openAddPendingUsersDialog) => (dispatch) => {
	dispatch(onToggleAddPendingUsersDialog(openAddPendingUsersDialog));
};

export const ToggleDeleteUserDialog = (openDeleteUserDialog, openDeleteUserDialogId) => (dispatch) => {
	dispatch(onToggleDeleteUserDialog(openDeleteUserDialog, openDeleteUserDialogId));
};

export const GetRoles = (role) => async (dispatch) => {
	await GetRolesRequest(role).then(response => {
		dispatch(onGetRoles(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetOperators = () => async (dispatch) => {
	await GetOperatorsRequest().then(response => {
		dispatch(onGetOperators(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetOperatorProjects = (operatorIds) => async (dispatch) => {
	await GetOperatorProjectsRequest(operatorIds).then(response => {
		dispatch(onGetOperatorProjects(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const CreateUser = (userData, role) => async (dispatch) => {
	await CreateUserRequest(userData).then(response => {
		dispatch(enqueueSnackbar({ message: 'New user created!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
		dispatch(ToggleAddEditUserDialog(false));
		dispatch(GetPendingUsers());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const EditUser = (userData, role) => async (dispatch) => {
	await EditUserRequest(userData).then(response => {
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
		dispatch(ToggleAddEditUserDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const GetUser = (userId) => async (dispatch) => {
	await GetUserRequest(userId).then(response => {
		dispatch(onGetUser(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ResendConfirmationEmail = (userId) => async (dispatch) => {
	await ResendConfirmationEmailRequest(userId).then(response => {
		dispatch(enqueueSnackbar({ message: 'Confirmation email sent!', options: { key: new Date().getTime() + Math.random(), variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeactivateUser = (userId, role) => async (dispatch) => {
	await DeactivateUserRequest(userId).then(response => {
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DeleteUser = (userId, role) => async (dispatch) => {
	await DeleteUserRequest(userId).then(response => {
		dispatch(GetUsers(role));
		dispatch(GetUsersStats());
		dispatch(ToggleDeleteUserDialog(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
